export default {
  Teacher: {
    Title: 'Giáo viên',
    ViewProfile: 'Xem hồ sơ của bạn',
    ProtectAccount: 'Bảo vệ tài khoản của bạn',
    EMISApps: 'Ứng dụng của EMIS'
  }
}
